// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17YEt","fullView":"styles_fullView__33Ep0"};